import { useCallback, useState } from 'react'

import { useUnit } from 'effector-react'

import { NavItem } from '@/components/layout/sidebar/nav/nav-item.tsx'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/collapse.tsx'
import { $account } from '@/models/account.ts'
import { $currentCreator } from '@/models/creators.ts'
import { classNames } from '@/utils/helpers.ts'
import { noop } from '@/utils/misc.ts'

import type { NavSingleButtonProps } from './nav-single-button.tsx'

export interface NavExpandableButtonProps extends NavSingleButtonProps {
  subItems: NavSingleButtonProps[]
}

export const NavExpandableButton = ({
  Icon,
  title,
  subItems,
  isDisabled,
  testId,
}: NavExpandableButtonProps) => {
  const [value, setValue] = useState<string>()
  const account = useUnit($account)
  const activeCreator = useUnit($currentCreator)

  const handleToggle = useCallback(() => {
    setValue((old) => (old ? '' : 'item-1'))
  }, [])

  return (
    <Accordion
      type="single"
      onValueChange={handleToggle}
      collapsible
      value={value}
    >
      <AccordionItem value="item-1">
        <AccordionTrigger
          disabled={isDisabled}
          data-testid={testId ? `navbar-${testId}-item` : undefined}
          className={classNames(
            'flex w-full items-center justify-between rounded-lg p-2.5 text-text-default hover:bg-neutral-contrast dark:hover:bg-secondary-600',
            {
              'text-gray-500': isDisabled,
            },
          )}
        >
          <div className="flex items-center gap-2">
            <Icon />
            <span className="text-sm font-medium">{title}</span>
          </div>
        </AccordionTrigger>

        {subItems
          .filter((item) => !item.canSee || item.canSee(activeCreator, account))
          .map((item) => (
            <AccordionContent
              className="px-4"
              key={
                item.title +
                '_' +
                item.href.replace(':creatorId', String(activeCreator?.id ?? 0))
              }
            >
              <NavItem
                item={item}
                onClick={noop}
              />
            </AccordionContent>
          ))}
      </AccordionItem>
    </Accordion>
  )
}
